module.exports = __webpack_public_path__ + "img/logo_head.321800e2.png";